import { useRef, useEffect } from 'react'

export const useFirstRender = (): boolean => {
  const firstRender = useRef(true)
  useEffect(() => {
    firstRender.current = false
  }, [])
  return firstRender.current
}

export const useNotFirstRender = (): boolean => {
  const notFirstRender = useRef(false)
  useEffect(() => {
    notFirstRender.current = true
  }, [])
  return notFirstRender.current
}
